"use client";

import { useSyncExternalStore } from "react";

const COARSE_POINTER_QUERY = "(pointer: coarse)";

// Server snapshot — assume non-touch (desktop) to avoid hydration mismatch.
function getServerSnapshot(): boolean {
  return false;
}

function getSnapshot(): boolean {
  return window.matchMedia(COARSE_POINTER_QUERY).matches;
}

function subscribe(callback: () => void): () => void {
  const mql = window.matchMedia(COARSE_POINTER_QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

/**
 * True when the device's PRIMARY pointer is coarse (touch) — i.e. a phone or
 * tablet, independent of viewport size or orientation.
 *
 * Used to route shared touch devices into the device-setup / PIN-login flow
 * (NAU-226 Decision 3) while mouse-driven desktops keep the standard
 * email/password login. Chosen over a width breakpoint because shared nursery
 * devices are tablets (an iPad is 768px portrait / 1024px landscape, which a
 * width gate misclassifies), and because `(pointer: coarse)` reflects the
 * primary pointer — a touchscreen laptop driven by a trackpad stays non-touch.
 */
export function useIsTouchDevice(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
